module.exports = __webpack_public_path__ + "media/images/overlay-db65898c4acc660a5214c25f574f3912.png";